<template>
    <d-resizable-dialog
        v-model   = "visible"
        :border   = "false"
        :title    = "name"
        :position = "{ x: position.x, y: position.y }"
        :size     = "{ width: size.width, height: size.height }"
    >
        <template v-slot:content>
            <c-dms-viewer
                class         = "dms-viewer"
                :document     = "document"
                :top-right    = "true"
                border-radius = "6px"
            />
        </template>
    </d-resizable-dialog>
</template>

<script>

import DResizableDialog from "@/modules/core/components/utils/DResizableDialog.vue";
import CDmsViewer       from "@/modules/dms/viewer/CDmsViewer.vue";

export default {
    name: "CDmsDragableViewer",

    components: {
        CDmsViewer,
        DResizableDialog,
    },

    data: () => ({
        document: null,
        name    : null,
        visible : false,
        position: {
            x: 0,
            y: 0
        },
        size: {
            width : 0,
            height: 0
        }
    }),

    created() {
        this.$bus.$on(this.$events.dms.fadein, this.onShow);
    },

    beforeDestroy() {
        this.$bus.$off(this.$events.dms.fadein, this.onShow);
    },

    mounted() {
        this.position.y = 195;
        this.position.x = window.innerWidth/2 - 2;
        this.size.width = window.innerWidth / 2 - 70;
        this.size.height = 747; //window.innerHeight - 40;
    },

    methods: {
        onShow (document) {
            this.name = document.name;
            this.document = document.id;
            this.visible = true;
        }
    }
}
</script>

<style scoped>

.dms-viewer {
    margin-top: 1px;
    padding-bottom: 0;

}

</style>